import { render, staticRenderFns } from "./MeuPerfil.vue?vue&type=template&id=1865dd5c&"
import script from "./MeuPerfil.vue?vue&type=script&lang=js&"
export * from "./MeuPerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports